import LoadingButton from '@mui/lab/LoadingButton';
import { createTheme } from "@mui/material/styles";
const theme = createTheme();

export interface iBasicButton {
  variant?: any, 
  isDisabled?: boolean, 
  size?: any, 
  isLoading?: boolean, 
  endIcon?: any, 
  color?: any, 
  type?:any, 
  label?:any,
  onClick?: any
}

export default function BasicButton(props:any) {
  const formatLabel = (text: string) => {
    if (!text) return "";
    return text.charAt(0).toUpperCase() + text.slice(1).toLowerCase();
  };
  return (
    <>
      <LoadingButton 
        sx={{  
          textTransform:"capitalize",
          fontWeight: 300
        }} 
        loadingPosition= {props?.endIcon ? "end" : undefined}
        {...props}
      >{formatLabel(props?.label || "Button")}
      </LoadingButton>
    </>
  );
}